import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ko from './locales/ko.json';
import en from './locales/en.json';
import zh from './locales/zh.json';
import ja from './locales/ja.json';
import es from './locales/es.json';

const STORAGE_KEY = 'vvt_lang';
const UI_TO_BE = { KOR: 'ko', ENG: 'en', CHN: 'zh', JPN: 'ja', SPA: 'es' };

function getInitialLanguage() {
  try {
    let ui = localStorage.getItem(STORAGE_KEY) || 'KOR';
    if (ui === 'ESP') {
      ui = 'SPA';
      localStorage.setItem(STORAGE_KEY, ui);
    }
    return UI_TO_BE[ui] || 'ko';
  } catch {
    return 'ko';
  }
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ko: { translation: ko },
      en: { translation: en },
      zh: { translation: zh },
      ja: { translation: ja },
      es: { translation: es },
    },
    lng: getInitialLanguage(),
    fallbackLng: 'ko',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

// 언어 변경 시 <html lang="..."> 자동 설정 (CSS 속성 선택자로 언어별 스타일 적용)
function syncHtmlLang(lng) {
  if (typeof document !== 'undefined' && document.documentElement) {
    document.documentElement.lang = lng;
  }
}
syncHtmlLang(i18n.language);
i18n.on('languageChanged', syncHtmlLang);

export default i18n;
